import { InfoCircleOutlined } from '@ant-design/icons';
import { Alert } from 'antd';

const searchStateText = 'Daha önceden eklenmiş yazarı tekrar eklememek için öncesinde sorgu yapabilirsiniz.';
const newAuthorStateText = 'Lütfen eklemek istediğiniz yazarın bilgilerini eksiksiz bir şekilde giriniz.';
function AlertArea({ isNewAuthorState = false }) {
  return (
    <Alert
      description={isNewAuthorState ? newAuthorStateText : searchStateText}
      type="warning"
      showIcon
      icon={<InfoCircleOutlined />}
    />
  );
}

export default AlertArea;
